import React, { useCallback } from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { FaRupeeSign } from "react-icons/fa";
import classNames from "classnames";
import classes from "./item.module.css";
import { useGalleryItem } from "../../Pregrine/Gallery/useGalleryItem";
import GetWishlist from "../../containers/Wishlist/GetWishlist";
import placeholder from "../../assets/images/placeholder.webp";
import { getProductImage } from "../../utility/getProductImage";
import { formatIndianNumber } from "../../utility/formatPrice";
import { getProductUnitSet } from "../../utility/getProductUnitSet";
import LazyImage from "./LazyImage";
import { getFlagText } from "../../utility/getFlagText";

const GalleryItem = React.memo((props) => {
  const { item, handleCart, setSelectedItem, buyNow, setBuyNow } = props;
  const talonProps = useGalleryItem({
    item,
    handleCart,
    setSelectedItem,
    buyNow,
    setBuyNow,
  });
  const {
    addButton,
    regularPrice,
    discountPrice,
    addToCompare,
    buyNowButton,
    isAddedToCompare,
    location,
  } = talonProps;

  const { ConfigData } = useSelector((state) => state.homePageSlice);

  const handleAddToCompare = useCallback(() => {
    addToCompare();
  }, [addToCompare]);

  const unitSet = getProductUnitSet(item);

  return (
    <>
      <div className={classes.item}>
        <div className={classes.productlisting}>
          <LazyImage
            alt={item.name}
            src={
              getProductImage(item, ConfigData?.base_media_url) || placeholder
            }
            urlKey={item.url_key}
            urlState={location.pathname}
            flagText={getFlagText(item) || ""}
          />

          {item.__typename.toLowerCase() !== "bundleproduct" &&
            item.__typename.toLowerCase() !== "configurableproduct" &&
            item.stock_status === "IN_STOCK" && (
              <div
                className={classNames(classes.compaireIcon, {
                  [classes.inCompare]: isAddedToCompare,
                })}
              >
                <button onClick={handleAddToCompare}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="1em"
                    height="1em"
                    viewBox="0 0 2048 2048"
                  >
                    <path
                      fill="currentColor"
                      d="M1817 1152h103v128h-22q-20 57-56 104t-85 81t-104 52t-117 19q-60 0-117-18t-105-52t-84-81t-56-105h-22v-128h103l187-560l-418-139v1213q169 11 317 75t272 179h179v128H128v-128h179q123-114 272-178t317-76V410L502 279l163 489h103v128h-22q-20 57-56 104t-85 81t-104 52t-117 19q-60 0-117-18t-105-52t-84-81t-56-105H0V768h103l187-560l-262-87L69 0l827 275V0h128v318l867 288l-41 122l-197-66zM606 896H162q35 60 94 94t128 34q69 0 128-34t94-94m-76-128L384 330L238 768zm430 1024q-118 0-231 32t-213 96h888q-99-63-213-95t-231-33m576-1078l-146 438h292zm222 566h-444q35 60 94 94t128 34q69 0 128-34t94-94"
                    ></path>
                  </svg>
                </button>
              </div>
            )}

          <div className={classes.productdiscription}>
            <strong>Item code : {item.sku}</strong>
            <Link
              state={{ url: location.pathname }}
              to={`/product/${item.url_key}.html`}
              className={classes.name}
            >
              <h2>{item.name}</h2>
            </Link>
            {unitSet ? (
              <small className={classes.unit}>Unit : {unitSet}</small>
            ) : (
              <small className={classes.unit} style={{ visibility: "hidden" }}>
                NA
              </small>
            )}

            <div
              className={classNames(
                "row d-flex justify-content-between align-items-center",
                classes.wrapper
              )}
            >
              {item?.new_price_bundle ? (
                <div style={{ display: "flex", justifyContent: "end" }}>
                  <span
                    style={{ color: "white", background: "black" }}
                    className="p-1 m-1"
                  >
                    {" "}
                    {item?.new_price_bundle}
                  </span>{" "}
                </div>
              ) : (
                <>
                  <div className="col-lg-12">
                    <div className={classes.pricetag}>
                      <div
                        className={classNames({
                          [classes.bundleCase]:
                            item.__typename === "BundleProduct",
                        })}
                      >
                        {discountPrice ? (
                          <>
                            <span className={classes.mrpText}>MRP</span>
                            <span className={classes.discountPrice}>
                              <FaRupeeSign />
                              <span>
                                {formatIndianNumber(regularPrice.value)}
                              </span>
                            </span>
                            <span>
                              <FaRupeeSign />
                              <span>
                                {formatIndianNumber(discountPrice.value)}
                              </span>
                            </span>
                            <span className={classes.discountOff}>
                              {item.__typename === "BundleProduct"
                                ? ` ${(
                                    ((regularPrice.value -
                                      discountPrice.value) *
                                      100) /
                                    regularPrice.value
                                  ).toFixed(2)} % OFF`
                                : `${item.price_range.minimum_price.discount.percent_off} % OFF`}
                            </span>
                          </>
                        ) : (
                          <span>
                            MRP
                            <FaRupeeSign />
                            <span>
                              {formatIndianNumber(regularPrice.value)}
                            </span>
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                  <small
                    className={classNames(classes.incl, {
                      [classes.bundleCase]: item.__typename === "BundleProduct",
                    })}
                  >
                    (Incl. of all taxes)
                  </small>
                </>
              )}

              <div className="col-lg-12 d-flex justify-content-between align-items-center">
                <div className={classes.wishlistIconWrapper}>
                  <GetWishlist item={item} itemId={item.id} />
                </div>
                <div className={classes.carticon}>
                  {addButton}
                  <div className={classes.buy_button}>{buyNowButton}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
});

export default GalleryItem;
